import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { useT } from "../lib/i18n";

export const Footer = () => {
  const t = useT();
  return (
    <footer
      data-testid="footer"
      className="bg-[#0D0D0D] text-bone border-t border-white/10 relative"
    >
      <div className="container-x py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Logo size={28} />
          <p className="mt-6 max-w-sm text-sm text-bone/60 leading-relaxed">
            {t("footer.bio")}
          </p>
        </div>
        <div>
          <div className="eyebrow mb-4">{t("footer.menu")}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-stone transition-colors">{t("nav.home")}</Link></li>
            <li><Link to="/portfolio" className="hover:text-stone transition-colors">{t("nav.portfolio")}</Link></li>
            <li><Link to="/about" className="hover:text-stone transition-colors">{t("nav.about")}</Link></li>
            <li><Link to="/boutique" className="hover:text-stone transition-colors">{t("nav.shop")}</Link></li>
            <li><Link to="/contact" className="hover:text-stone transition-colors">{t("nav.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">{t("footer.social")}</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-stone" />
              <a href="mailto:romain.bruneauprod@gmail.com" data-testid="footer-email" className="hover:text-stone">romain.bruneauprod@gmail.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} className="text-stone" />
              <a href="tel:+33606465046" data-testid="footer-phone" className="hover:text-stone">+33 6 06 46 50 46</a>
            </li>
            <li className="flex items-center gap-2">
              <Instagram size={14} className="text-stone" />
              <a href="https://www.instagram.com/romain.bruneau/" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="hover:text-stone">@romain.bruneau</a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin size={14} className="text-stone" />
              <span className="text-bone/70">Pau · France</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="container-x border-t border-white/10 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] tracking-[0.2em] uppercase text-bone/40">
        <span>© {new Date().getFullYear()} Romain Bruneau · {t("footer.rights")}</span>
        <span data-testid="footer-legal" className="text-bone/40 normal-case tracking-normal text-[11px]">
          NOVEA PRODUCTION · 10 Avenue du Cheminet, 44120 Vertou · SIRET 979 815 750 00042 · TVA FR02 979 815 750
        </span>
      </div>
    </footer>
  );
};

export default Footer;
